export const PAY_BY_ME_VPOS_PAYMENT_START = 'PAY_BY_ME_VPOS_PAYMENT_START';
export const PAY_BY_ME_VPOS_PAYMENT_SUCCESS = 'PAY_BY_ME_VPOS_PAYMENT_SUCCESS';
export const PAY_BY_ME_VPOS_PAYMENT_FAIL = 'PAY_BY_ME_VPOS_PAYMENT_FAIL';
export const PAY_BY_ME_VPOS_PAYMENT_RESET = 'PAY_BY_ME_VPOS_PAYMENT_RESET';
